

window.addEventListener("load", function () {
  const marqueeHeader = document.querySelector(".tag-marquee-header");
  if (marqueeHeader) {
    const count = 30;
    for (let i = 0; i < count; i++) {
      const item = document.createElement("div");
      item.className = "text";
      marqueeHeader.appendChild(item);
    }
  }

  const header = document.querySelector("#ovensmash-26-pre-header");
  const videoGameplay = header?.querySelector(".video_gameplay");
  const btnVideo = header?.querySelector(".btn-video");

  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  if (videoGameplay) {
    if (isMobile()) {
      videoGameplay.classList.add("is-visible");
    }

    const SCROLL_THRESHOLD_PX = 100;
    const onScroll = () => {
      if (window.scrollY >= SCROLL_THRESHOLD_PX) {
        videoGameplay.classList.add("is-visible");
      } else if (!isMobile()) {
        videoGameplay.classList.remove("is-visible");
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  if (btnVideo && videoGameplay) {
    btnVideo.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({ top: isMobile() ? 400 : 500, behavior: "smooth" });
      videoGameplay.classList.add("is-visible");
    });
  }

  // if (videoGameplay && isMobile()) {
  //   videoGameplay.addEventListener("click", () => {
  //     window.scrollTo({ top: 100, behavior: "smooth" });
  //   });
  // }
});
